import Vue from "vue";
import { getCurrentLang, DEFAULT_LANG } from "@/utils/lang";
import messages from "@/locales";

// 按点号路径从对象中取值，例如 resolve(obj, "home.tryAsk")
function resolve(obj, key) {
  if (!obj) return undefined;
  return key.split(".").reduce((acc, part) => {
    return acc && typeof acc === "object" ? acc[part] : undefined;
  }, obj);
}

// 简单变量插值：$t("a.b", { name: "x" }) -> 文案中的 {name} 被替换
function interpolate(text, params) {
  if (!params || typeof text !== "string") return text;
  return text.replace(/\{(\w+)\}/g, (match, name) => {
    return Object.prototype.hasOwnProperty.call(params, name) ? params[name] : match;
  });
}

// 轻量 i18n：按 cookie currentLang 取值，缺失回退默认语言，再缺失返回 key
Vue.prototype.$t = function (key, params) {
  const lang = getCurrentLang();
  let text = resolve(messages[lang], key);
  if (text === undefined) {
    text = resolve(messages[DEFAULT_LANG], key);
  }
  if (text === undefined) {
    return key;
  }
  return interpolate(text, params);
};

export default Vue.prototype.$t;
